import * as React from 'react';
import clsx from 'clsx';

import { formatStartTime } from 'lib/util/formatStartTime';
import { LinkableTextArea } from 'components/LinkableTextArea/LinkableTextArea';
import { ProductShape } from 'lib/util/productShape';
import { applyRelativeTimeOffset } from 'lib/util/applyRelativeTimeOffset';

import baseStyles from '../../base.module.css';
import styles from '../ProductDetailsView.module.css';

interface Props {
  product: ProductShape;
}

export const ScheduleTab = ({ product }: Props) => {
  const [selectedStartTime, setSelectedStartTime] = React.useState<string>(
    product.startTimes.length > 0 ? product.startTimes[0].hhMm : ''
  );
  const handleStartTimeChange = (event: React.ChangeEvent<HTMLSelectElement>) =>
    setSelectedStartTime(event.target.value);

  return (
    <>
      <label className={styles['overview__content__item__select']}>
        <select name="startTime" value={selectedStartTime} onChange={handleStartTimeChange}>
          {product.startTimes.map((startTime) => (
            <option key={startTime.hhMm} value={startTime.hhMm}>
              {formatStartTime(startTime)}
            </option>
          ))}
        </select>
      </label>
      <div className={styles['overview__content__item__scheds']}>
        {product.schedule.map((event) => {
          const eventStartTime = event.startTimeRelative
            ? applyRelativeTimeOffset(selectedStartTime, event.startTimeRelative)
            : '';
          const eventEndTime = event.endTimeRelative
            ? applyRelativeTimeOffset(selectedStartTime, event.endTimeRelative)
            : '';

          const timeDescription = eventEndTime
            ? `${eventStartTime} - ${eventEndTime}`
            : eventStartTime;

          return (
            <div key={event.name} className={styles['overview__content__item__scheds__item']}>
              <p className={styles['overview__content__item__scheds__item__time']}>
                {timeDescription}
              </p>
              <div className={styles['overview__content__item__scheds__item__point']}>
                <p className={baseStyles['color-bg--black']}></p>
                <p className={baseStyles['color-bg--black']}></p>
              </div>
              <div className={styles['overview__content__item__scheds__item__info']}>
                <p className={styles['overview__content__item__scheds__item__info__ttl']}>
                  {event.name}
                </p>
                <p
                  className={clsx(
                    styles['overview__content__item__scheds__item__info__desc'],
                    'newline'
                  )}
                >
                  <LinkableTextArea>{event.description}</LinkableTextArea>
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
